export const SCOPE_WARNING_MESSAGE =
  'The internal components of the InputText must be its own elements. For more information, see the documentation.'
